import React, { useState } from 'react'
import Input from '@shared/input'
import SharedFlatpickr from "@shared/flatpickr"
import AccountingExportOptions from './accountingExportOptions'

const ExportTypes = ({ 
  exports,
  selectedFormat,
  setSelectedFormat,
  setShowExportDisplay,
  displayableExports,
  email,
  setEmail,
  accounting
}) => {
  const [accountingDate, setAccountingDate] = useState("")

  const onSelect = e => {
    setSelectedFormat(e.target.value)
    setShowExportDisplay(false)
  }

  const LINES = "yuman_lines"
  const PCA   = "pca"

  const nothingLeft = !!accounting && accounting.exportableCount === 0

  return(
    <>
      {
        exports.map(([name, format]) =>
          <div key = {name}>
            <div className = "radio radio-primary" >
              <input 
                id       = {`format_${name}`}
                name     = "export_format"
                type     = "radio" 
                value    = {format}
                checked  = {selectedFormat === format}
                onChange = {onSelect}
              />
              <label htmlFor={`format_${name}`}>
                {name}
              </label>
            </div>
              
            {selectedFormat === format && !displayableExports.includes(selectedFormat) && (
              <>
                {selectedFormat === PCA && (
                  <div className="form-group">
                    <label required>{I18n.t("invoices.accounting_date")}</label>

                    <SharedFlatpickr
                      className="form-control flatpickr-nobg"
                      name="accounting_date"
                      value={accountingDate}
                      onChange={([date]) => setAccountingDate(date.toISOString())}
                      options={{
                          mode: "single",
                          dateFormat: "d/m/Y",
                          locale: I18n.locale,
                      }}
                      required
                    />
                  </div>
                )}
                <div className = "form-group">
                  <Input
                    name         = "email"
                    type         = "email"
                    defaultValue = {email}
                    className    = "form-control"
                    onChange     = {setEmail}
                    label        = {I18n.t("invoices.preferred_email")}
                    required
                  />
                </div>

                <input
                  type  = "hidden"
                  name  = "export_mode"
                  value = "send_by_email"
                />
              </>
            )}

            {selectedFormat === format && accounting && <AccountingExportOptions {...accounting} />}

            {selectedFormat === LINES &&
              <input
                type         = "hidden"
                name         = "with_lines"
                defaultValue = {true}
              />
            }
          </div>
        )
      }

      <div className = "modal-buttons">
        { displayableExports.includes(selectedFormat) 
          ? <button 
              type      = "button" 
              className = "btn btn-primary" 
              disabled  = {nothingLeft}
              onClick   = {() => setShowExportDisplay(true)}>
                {I18n.t("button.next")}
              </button>
          : <button 
              type      = "submit" 
              className = "btn btn-primary" 
              disabled  = {!selectedFormat || nothingLeft}>
                {I18n.t("invoices.send")}
              </button>
        }
      </div>
    </>
  )
}

export default ExportTypes